<template>
  <span v-if="isVisible && hasContent" class="construct-visual-renderer">
    <ConstructVisualRenderer
      v-for="(child, index) in content"
      :key="index"
      :item="child"
      :line="line"
      :page="page"
      :itemData="itemData"
      :actionResolver="actionResolver"
      @action="$emit('action', $event)"
    />
  </span>
  <span
    v-else-if="isVisible && componentName"
    class="construct-visual-renderer"
    :class="{ 'construct-visual-action': actionState.enabled, 'construct-visual-action-disabled': actionState.matched && !actionState.enabled }"
    @click="activate"
  >
    <component
      :is="componentName"
      :item="item"
      :line="line"
      :page="page"
      :itemData="itemData"
      :actionResolver="actionResolver"
      @action="$emit('action', $event)"
    />
  </span>
  <span v-else-if="isVisible && item && !componentName" class="red--text text-caption">Type visuel inconnu : {{ item.type }}</span>
</template>

<script>
import Column from './Column.vue'
import Group from './Group.vue'
import TextVisual from './Text.vue'
import HtmlVisual from './Html.vue'
import DateVisual from './Date.vue'
import CollectionVisual from './Collection.vue'
import ImageVisual from './Image.vue'
import MdiVisual from './Mdi.vue'
import Badge from './Badge.vue'
import visuelConditions from '../../../../../mixins/visuelConditions'

export default {
  name: 'ConstructVisualRenderer',
  mixins: [visuelConditions],
  props: {
    item: { type: Object, default: null },
    content: { type: Array, default: null },
    line: { type: Object, default: () => ({}) },
    itemData: { type: [Object, Array, String, Number, Boolean], default: null },
    page: { type: [String, Number], default: null },
    actionResolver: { type: Function, default: null },
  },
  components: { Column, Group, TextVisual, HtmlVisual, DateVisual, CollectionVisual, ImageVisual, MdiVisual, Badge },
  computed: {
    actionState() {
      if (!this.actionResolver || !this.item || !this.item.key || ['column', 'collection'].includes(this.item.type)) return { matched: false, enabled: false }
      return this.actionResolver({ key: this.item.key, line: this.line, itemData: this.itemData }) || { matched: false, enabled: false }
    },
    hasContent() { return Array.isArray(this.content) },
    isVisible() {
      if (!this.item || !Array.isArray(this.item.visuelcond) || !this.item.visuelcond.length) return true
      const results = this.visuelConditions(this.item.visuelcond, this.line, this.page, this.itemData)
      return results.length > 0 && results.every(value => value === true)
    },
    componentName() {
      if (!this.item) return null
      return {
        column: 'Column', group: 'Group', text: 'TextVisual', html: 'HtmlVisual', date: 'DateVisual',
        collection: 'CollectionVisual', image: 'ImageVisual',
        mdi: 'MdiVisual', badge: 'Badge',
      }[this.item.type]
    },
  },
  methods: {
    activate(event) {
      // Native links keep their own navigation and never launch a surrounding action.
      if (this.actionResolver && event.target && event.target.closest && event.target.closest('a[href], button, input, select, textarea')) {
        event.stopPropagation()
        return
      }
      if (!this.actionState.matched) return
      event.stopPropagation()
      if (!this.actionState.enabled) return
      this.$emit('action', { key: this.item.key, line: this.line, itemData: this.itemData, event })
    },
  },
}
</script>

<style scoped>
.construct-visual-renderer {
  display: contents;
}
.construct-visual-action { cursor: pointer; }
.construct-visual-action-disabled { cursor: default; }
</style>
